<template>
	<el-tabs v-model="activeName" type="card">
		<el-tab-pane label="异常处理" name="first">
			<div class="service">
				<form-screen
					:form-data="formData"
					page-type="server"
					@formChange="getSonCompanyList"
					@confirm="formConfirm"
					@resetSonCompany="resetSonCompany"
					placeholder="、国内运单、国内单号、采购单号"
				/>
				<el-table
					:data="listTable"
					border
					style="width: 100%"
					:header-cell-style="{ textAlign: 'center' }"
					v-loading="loadingTable"
				>
					<el-table-column label="采购单号/国内单号" width="220">
						<template slot-scope="scope">
							<p>采购单号：{{ scope.row.purchaseNumber }}</p>
							<p>
								国内单号：{{ scope.row.internalConveyNumber }}
							</p>
						</template>
					</el-table-column>
					<el-table-column prop="orderId" label="订单号" width="240">
						<template slot-scope="scope">
							<div v-if="scope.row.purchaseFrom !== 2">
								<div>订单号：{{ scope.row.amazonOrderId }}</div>
								<div>订单ID：{{ scope.row.orderId }}</div>
							</div>
							<div v-else>
								<div>库存编号：{{ scope.row.inventoryNo }}</div>
							</div>
							<el-row style="display: flex;align-items: center;">
								<el-popover
									placement="top-start"
									title="物流内部备注"
									width="650"
									trigger="hover"
								>
									<el-table
										:data="RemarkList"
										style="width: 100%"
									>
										<el-table-column
											prop="roleName"
											label="添加人"
											width="120"
											align="center"
										></el-table-column>
										<el-table-column
											prop="remarkContent"
											label="内容"
											width="330"
											align="center"
										></el-table-column>
										<el-table-column
											prop="createTime"
											label="时间"
											width="200"
											align="center"
										></el-table-column>
									</el-table>
									<i
										class="el-icon-s-order"
										style="font-size:18px;"
										slot="reference"
										@mouseover="orderIdchange(scope.row)"
									></i>
								</el-popover>
								<el-tag
									v-if="scope.row.outInterceptStatus === 1"
									type="danger"
									effect="dark"
									size="mini"
									>拦截</el-tag
								>
								<el-tooltip
									class="item"
									effect="dark"
									content="订单冻结"
									placement="bottom"
									v-if="scope.row.isFreeze === 1"
								>
									<i
										class="element-icons hx-snow"
										style="font-size: 40px;color: #1296db;line-height: 40px;"
									></i>
								</el-tooltip>
							</el-row>
						</template>
					</el-table-column>
					<el-table-column
						prop=""
						label="异常信息"
						align="left"
						width="300px"
					>
						<template slot-scope="scope">
							<el-row type="flex">
								<div
									v-if="
										scope.row.exceptionImages !== null &&
											scope.row.exceptionImages !== []
									"
								>
									<el-popover
										trigger="hover"
										placement="right"
									>
										<img
											:src="scope.row.exceptionImages[0]"
											alt
											style="width:500px;height:500px;"
										/>
										<div class="scope_img" slot="reference">
											<img
												:src="
													scope.row.exceptionImages[0]
												"
												alt
												style="width:50px;height:50px;margin-left:10px;"
											/>
										</div>
									</el-popover>
								</div>
								<div style="margin-left:10px;">
									<p>{{ scope.row.exceptionRemark }}</p>
								</div>
							</el-row>
						</template>
					</el-table-column>
					<el-table-column
						prop="handleDescription"
						label="处理方案"
						align="center"
						width="140px"
					></el-table-column>
					<el-table-column
						prop="exceptionResult"
						label="状态"
						width="140"
						align="center"
					>
						<template slot-scope="scope">
							<div
								style="color: red;"
								v-if="scope.row.exceptionResult === 0"
							>
								未处理
							</div>
							<div
								style="color:blue;"
								v-else-if="scope.row.exceptionResult === 1"
							>
								申请退件
							</div>
							<div
								style="color:green;"
								v-else-if="scope.row.exceptionResult === 2"
							>
								确认退件
							</div>
							<div
								style="color:blue;"
								v-else-if="scope.row.exceptionResult === 3"
							>
								申请转库存
							</div>
							<div
								style="color:green;"
								v-else-if="scope.row.exceptionResult === 4"
							>
								确认转库存
							</div>
							<div
								style="color:blue;"
								v-else-if="scope.row.exceptionResult === 5"
							>
								申请取消异常
							</div>
							<div
								style="color:green;"
								v-else-if="scope.row.exceptionResult === 6"
							>
								确认取消异常
							</div>
							<div
								style="color:blue;"
								v-else-if="scope.row.exceptionResult === 9"
							>
								申请转未知
							</div>
							<div
								style="color:green;"
								v-else-if="scope.row.exceptionResult === 10"
							>
								确认转未知
							</div>
						</template>
					</el-table-column>
					<!-- <el-table-column label="核对结果" align="center" width="100">
                        <template slot-scope="scope">
                            <div style="color: #0565b7;" v-if="scope.row.checkResult === 0">未核对</div>
                            <div style="color: green;" v-else-if="scope.row.checkResult === 1">核对正确</div>
                            <div style="color: red;" v-else-if="scope.row.checkResult === 2">核对错误</div>
                        </template>
                    </el-table-column> -->
					<el-table-column
						prop="errorTime"
						label="报错时间"
						width="110"
						sortable
						align="center"
					></el-table-column>
					<el-table-column
						width="200"
						prop="errorRoleId"
						label="报错角色"
						align="center"
					>
						<template slot-scope="scope">
							<div>
								<span>{{ scope.row.roleName }}</span>
								<span
									v-if="
										scope.row.roleName && scope.row.userName
									"
									>&nbsp;-&nbsp;</span
								>
								<span>{{ scope.row.userName }}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="handleTime"
						label="处理时间"
						width="110"
						sortable
						align="center"
					></el-table-column>
					<!-- <el-table-column prop="updateTime" label="更新时间" width="200" sortable align="center"></el-table-column> -->
					<el-table-column
						prop="putStorageTime"
						label="入库时间"
						width="110"
						sortable
						align="center"
					></el-table-column>
					<el-table-column label="尺寸/重量" width="150">
						<template slot-scope="scope">
							<p>尺寸：{{ scope.row.purchaseSize }}</p>
							<p>重量：{{ scope.row.purchaseWeight }}</p>
						</template>
					</el-table-column>
					<el-table-column
						label="货物类型/货物等级"
						width="180"
						align="center"
					>
						<template slot-scope="scope">
							<p>货物类型：{{ scope.row.purchaseTypeCode }}</p>
							<p>货物等级：{{ scope.row.purchaseClass }}</p>
						</template>
					</el-table-column>
					<!-- <el-table-column prop="purchaseClass" label="货物等级" align="center"></el-table-column> -->
					<!-- <el-table-column prop="branchCompanyName" label="所属分公司" width="200" align="center"></el-table-column>
                    <el-table-column prop="subCompanyName" label="所属子公司" width="200" align="center"></el-table-column> -->
					<el-table-column
						width="200"
						prop="ziName"
						label="所属公司"
						align="center"
					>
						<template slot-scope="scope">
							<div>
								<span>{{ scope.row.branchCompanyName }}</span>
								<span
									v-if="
										scope.row.branchCompanyName &&
											scope.row.subCompanyName
									"
									>&nbsp;-&nbsp;</span
								>
								<span>{{ scope.row.subCompanyName }}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						fixed="right"
						label="操作"
						width="80"
						align="center"
					>
						<template slot-scope="scope">
							<i
								class="el-icon-edit-outline fontSize-30"
								@click="edit(scope.row)"
							></i>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination-container">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="page"
						:page-sizes="[20, 50, 100, 200, 300]"
						:page-size="size"
						layout="total, sizes,prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</div>
				<!-- 信息核对 -->
				<ServiceDepartment
					ref="ServiceDepartment"
					@confirm="ServiceDepartmentConfirm"
				/>
			</div>
		</el-tab-pane>
		<el-tab-pane label="未知处理" name="second">
			<unknown></unknown>
		</el-tab-pane>
		<el-tab-pane label="异常处理记录" name="third">
			<AbnormalRecords></AbnormalRecords>
		</el-tab-pane>
		<el-tab-pane label="未知处理记录" name="fourth">
			<unknownRecords></unknownRecords>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
import formScreen from './InformationDepartment/formScreen'
import ServiceDepartment from './serviceDepartment/serviceDepartment'
import unknown from './serviceDepartment/unknown'
import AbnormalRecords from './serviceDepartment/AbnormalRecords'
import unknownRecords from './serviceDepartment/unknownRecords'

import { ajaxPost, Baseurl } from '@/api/api/api'

export default {
	name: 'service',
	components: {
		formScreen,
		ServiceDepartment,
		unknown,
		AbnormalRecords,
		unknownRecords,
	},
	data() {
		return {
			activeName: 'first',
			formData: {
				listBranch: [],
				roleList: [],
				listSon: [],
				listChannel: [],
			},
			formScreenData: {},
			listTable: [],
			page: 1,
			size: 20,
			total: 0,
			UserInfo: {},
			loadingTable: false,
			RemarkList: [],
		}
	},
	created() {
		this.UserInfo = JSON.parse(localStorage.getItem('role'))
		this.getTableData()
		this.getBranchCompanyList()
		this.getErrorRoleNameList()
	},
	methods: {
		handleSizeChange(val) {
			// console.log(`每页 ${val} 条`);
			this.size = val
			this.getTableData()
		},
		handleCurrentChange(val) {
			// console.log(`当前页: ${val}`);
			this.page = val
			this.getTableData()
		},
		edit(row) {
			this.$refs.ServiceDepartment.init(row)
		},
		ServiceDepartmentConfirm(data) {
			console.log(data)
			const API =
				Baseurl + 'logisticsController/updatePurchaseExceptionResult'
			const paramsData = {
				roleId: this.UserInfo.rid,
				companyId: this.UserInfo.company_id,
				...data,
			}
			ajaxPost(API, paramsData).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.$refs.ServiceDepartment.close()
					this.getTableData()
					this.$message.success('操作成功')
				}
			})
		},
		getTableData() {
			const API = Baseurl + 'logisticsController/getServicePurchaseList'
			const paramsData = {
				companyId: this.UserInfo.company_id,
				page: this.page,
				size: this.size,
				listType: '2',
				...this.formScreenData,
			}
			console.log(this.formScreenData)
			this.loadingTable = true
			ajaxPost(API, paramsData).then((res) => {
				const { code, data } = res.data
				this.loadingTable = false
				if (code === 200) {
					this.listTable = data.list
					this.total = data.total
				}
			})
		},
		formConfirm(data, type) {
			if (type === 'reset') this.formData.listSon = []
			this.formScreenData = data
			this.page = 1
			this.getTableData()
		},
		resetSonCompany() {
			this.page = 1
			this.formData.listSon = []
		},
		getBranchCompanyList() {
			const API = Baseurl + 'logisticsController/getAllBranchCompany'
			ajaxPost(API).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.formData.listBranch = data
				}
			})
		},
		getErrorRoleNameList() {
			ajaxPost(Baseurl + 'logisticsController/getErrorRoleNameList').then(
				(res) => {
					const { code, data } = res.data
					if (code == 200) {
						this.formData.roleList = data
					}
				}
			)
		},
		getSonCompanyList(id) {
			const API = Baseurl + 'logisticsController/getAllSubCompanyById'
			const paramsData = { id }
			ajaxPost(API, paramsData).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.formData.listSon = data
				}
			})
		},
		orderIdchange(val) {
			const API =
				Baseurl + 'logisticsRemarkController/selectLogisticsRemarkList'
			const paramsData = {
				orderId: val.orderId,
			}
			ajaxPost(API, paramsData).then((res) => {
				if (res.data.code === 200) {
					this.RemarkList = res.data.data
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
	},
}
</script>

<style lang="scss" scoped>
.service {
	width: 98%;
	margin-top: 30px;
	padding-bottom: 72px;
	.header-button-box {
		margin: 10px 0;
	}
	.custom-out-form {
		.el-form-item {
			margin: 0;
		}
	}
	.pagination-container {
		width: 1660px;
		padding: 20px;
		position: fixed;
		right: 0;
		bottom: 0;
		background: #fff;
		z-index: 999;
		.el-pagination {
			display: flex;
			justify-content: center;
		}
	}
}
</style>
